export interface Testimonial {
  name: string
  location: string
  quote: string
  avatar: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Florencia Gaitán',
    location: 'Rosario, Argentina',
    quote:
      '“Trabajo casi todo el día desde casa y tenía el escritorio metido en un rincón porque era donde entraba. Lo cambié de lugar, saqué un par de cosas que tenía acumuladas y quedó otro ambiente. No pensé que algo tan simple me iba a cambiar tanto las ganas de sentarme a laburar.”',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/c53f34e9-7530-41f3-9c29-605f50df94c7.jpg',
  },
  {
    name: 'Daniela Rincón',
    location: 'Bucaramanga, Colombia',
    quote:
      '“Yo siempre había escuchado hablar del Feng Shui, pero pensaba que era poner una fuente o un bambú y ya. Me gustó entender por qué se recomienda cada cosa. Empecé por la entrada y mi cuarto, y la casa se siente mucho más tranquila.”',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/23462fe0-3dc1-4173-b2e0-beecc94f186c.jpg',
  },
  {
    name: 'Mónica Treviño',
    location: 'Querétaro, México',
    quote:
      '“Lo compré más por curiosidad que otra cosa y terminé moviendo medio estudio jajaja. Trabajo ahí todos los días y tenía la puerta justo detrás de mí. Hice varios cambios sin comprar nada y ahora siento el espacio muchísimo más cómodo.”',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/d4e3ad5a-73df-40db-b0de-fc7265948a99.jpg',
  },
  {
    name: 'Paula Arancibia',
    location: 'Viña del Mar, Chile',
    quote:
      '“Lo que más me sirvió fue la parte de los ambientes. Mi pieza se veía bonita, pero tenía escritorio, computador, papeles y todo mezclado con el descanso. Cambié algunas cosas y se siente mucho menos pesada cuando termino la pega.”',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/2e5fc6fb-c811-453a-b2fd-de3511c2c068.jpg',
  },
  {
    name: 'Claudia Valdivia',
    location: 'Arequipa, Perú',
    quote:
      '“Al comienzo el tema del Bagua me parecía medio complicado, pero con la plantilla lo entendí rapidísimo. Me puse a revisar mi depa y encontré varios rincones que tenía completamente olvidados. Me gustó porque no te obliga a comprar cosas para poder aplicarlo.”',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/46337f74-720e-4284-89f6-4860fbfbbdd3.jpg',
  },
  {
    name: 'Mariela Suárez',
    location: 'Santa Cruz de la Sierra, Bolivia',
    quote:
      '“Hace tiempo quería hacer algo con mi casa porque sentía que estaba todo puesto por poner. Me ayudó bastante la parte de colores y elementos, sobre todo para no seguir cargando los espacios. Fui haciendo cambios de a poco y quedó mucho más armonioso.”',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/4c6ea900-9383-411a-8b0b-25d60db9c2d4.jpg',
  },
]
